module.exports = __webpack_public_path__ + "img/invoice.7c632389.svg";